// @flow
import React from 'react';

class SMOptionalServiceSentView extends React.Component {

  render() {
    return (
      <div className="site-main">
        <div className="page__even">
          <div className="container">
            <h2 className="enterprise__contact-title">お問い合わせを送信しました</h2>
            <p className="enterprise__contact-text">
              {this.props.optionalServiceTitle}のお問い合わせありがとうございました！<br />
              担当よりご連絡いたしますので、 しばらくお待ちください。
            </p>
            <div className="ta-c mb50">
              <a href={Routes.root_path} className="button-blue mt20 pt15 pb15 w300 sm-w100">{I18n.t("service.label_000114")}</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SMOptionalServiceSentView;



// WEBPACK FOOTER //
// ./app/javascript/components/optional_services/SMOptionalServiceSentView.jsx